export const ANALYTICS_PROPERTIES = {
  name: 'name',
  modal_name: 'modal_name',
  screen: 'screen',
  homeId: 'homeId',
};
